module.exports = __webpack_public_path__ + "fonts/iconfont.c6a74f9.woff2";